import {
  FAMILYCONTACTTYPE_LOADING,
  GET_FAMILYCONTACTTYPE,
  GET_FAMILYCONTACTTYPE_SUCCESS,
  GET_FAMILYCONTACTTYPE_FAIL,
  ADD_FAMILYCONTACTTYPE_SUCCESS,
  ADD_FAMILYCONTACTTYPE_FAIL,
  DELETE_FAMILYCONTACTTYPE_SUCCESS,
  DELETE_FAMILYCONTACTTYPE_FAIL,
  UPDATE_FAMILYCONTACTTYPE_SUCCESS,
  UPDATE_FAMILYCONTACTTYPE_FAIL,
  FAMILYCONTACTTYPE_RESET
} from "./actionType";

const INIT_STATE = {
  familyContactTypes: [],
  error: {},
};

const FamilyContactType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FAMILYCONTACTTYPE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_FAMILYCONTACTTYPE:
          return {
            ...state,
            familyContactTypes: action.payload.data,
            isFamilyContactTypeCreated: false,
            isFamilyContactTypeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_FAMILYCONTACTTYPE_FAIL:
      switch (action.payload.actionType) {
        case GET_FAMILYCONTACTTYPE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isFamilyContactTypeCreated: false,
            isFamilyContactTypeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_FAMILYCONTACTTYPE: {
      return {
        ...state,
        isFamilyContactTypeCreated: false,
        loading: true,
      };
    }

    case FAMILYCONTACTTYPE_LOADING: {
      return {
        ...state,
        isFamilyContactTypeCreated: false,
        loading: true,
      };
    }

    case ADD_FAMILYCONTACTTYPE_SUCCESS:
      return {
        ...state,
        isFamilyContactTypeCreated: true,
        loading: false,
        familyContactTypes: [action.payload.data, ...state.familyContactTypes],
      };

    case ADD_FAMILYCONTACTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_FAMILYCONTACTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        familyContactTypes: state.familyContactTypes.filter(
          familyContactType => familyContactType.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_FAMILYCONTACTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_FAMILYCONTACTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        familyContactTypes: state.familyContactTypes.map(familyContactType =>
          familyContactType.id.toString() === action.payload.data.id.toString() ? { ...familyContactType, ...action.payload.data } : familyContactType
        ),
      };

    case UPDATE_FAMILYCONTACTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FAMILYCONTACTTYPE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default FamilyContactType;